import React from 'react';
import { useIntl } from 'react-intl';
import TextInputView from './common/TextInputView';
import AddressInputView from './common/AddressInputView';
import SuffixTextInputView from './common/SuffixTextInputView';
import TextareaInputView from './common/TextareaInputView';
import MultiFileInputView from './common/MultiFileInputView';
import HistoryView from './common/HistoryView';
import PortfolioView from './common/PortfolioView';
import { useSelector } from 'react-redux';
import MultiTextInputView from './common/MultiTextInputView';
import ImageInputView from './common/ImageInputView';
import { getUnit } from 'Util/NumberUtils';

const OptionsSection = ({ userInfo, recruitInfo, onChangeUserInfo, onChangeRecruitInfo, onChangeMultiUserInto }) => {
  const authUser = useSelector(store => store.authUser);
  const { country } = useSelector(state => state.settings);
  const { formatMessage } = useIntl();
  if (!userInfo || !recruitInfo) return <></>;
  const { managerPhone, businessPhone, businessAddress, businessAddress2 } = userInfo;
  const { capitalStock, companyHistories, portfolios, introduce, docs, majorClients, logo } = recruitInfo;

  return (
    <div>
      <ImageInputView title={formatMessage({ id: 'recruitment.logo' })} name="logo" value={logo} onChange={onChangeRecruitInfo} />
      <TextInputView
        title={formatMessage({ id: 'recruitment.managerPhone' })}
        placeholder={formatMessage({ id: 'recruitment.managerPhone.placeholder' })}
        isSmall
        name="managerPhone"
        value={managerPhone}
        onChange={onChangeUserInfo}
      />
      <TextInputView
        title={formatMessage({ id: 'recruitment.businessPhone' })}
        placeholder={formatMessage({ id: 'recruitment.businessPhone.placeholder' })}
        isSmall
        name="businessPhone"
        value={businessPhone}
        onChange={onChangeUserInfo}
      />
      {authUser?.token && <AddressInputView address={businessAddress} address2={businessAddress2} onChange={onChangeMultiUserInto} />}
      <SuffixTextInputView
        title={formatMessage({ id: 'recruitment.capitalStock' })}
        placeholder={formatMessage({ id: 'recruitment.capitalStock' })}
        isSmall
        name="capitalStock"
        value={capitalStock}
        onChange={onChangeRecruitInfo}
        suffix={getUnit(country)}
      />
      <MultiTextInputView
        title={formatMessage({ id: 'recruitment.majorClients' })}
        placeholder={formatMessage({ id: 'recruitment.majorClients.placeholder' })}
        name="majorClients"
        value={majorClients}
        onChange={onChangeRecruitInfo}
      />
      <HistoryView value={companyHistories} onChange={onChangeRecruitInfo} />
      <PortfolioView value={portfolios} onChange={onChangeRecruitInfo} />
      <TextareaInputView
        title={formatMessage({ id: 'recruitment.introduce' })}
        placeholder={formatMessage({ id: 'recruitment.introduce.placeholder' })}
        limit={350}
        name="introduce"
        onChange={onChangeRecruitInfo}
        value={introduce}
      />
      {authUser?.token && (
        <MultiFileInputView
          title={formatMessage({ id: 'recruitment.doc' })}
          placeholder={formatMessage({ id: 'recruitment.doc.placeholder' })}
          name="docs"
          onChange={onChangeRecruitInfo}
          value={docs}
          errText={formatMessage({ id: 'recruitment.doc.errText' })}
          subText={formatMessage({ id: 'recruitment.doc.subtext' })}
        />
      )}
    </div>
  );
};

export default OptionsSection;
